import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-039ef828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-content-wrap" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "van-hairline--bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "被保人类型", -1))
const _hoisted_5 = { class: "radio-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人姓名", -1))
const _hoisted_8 = {
  key: 1,
  class: "van-hairline--bottom"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人身份证号码", -1))
const _hoisted_10 = {
  key: 2,
  class: "van-hairline--bottom"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业名称", -1))
const _hoisted_12 = {
  key: 3,
  class: "van-hairline--bottom"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业的统一社会信用代码", -1))
const _hoisted_14 = {
  key: 4,
  class: "van-hairline--bottom"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "团体名称", -1))
const _hoisted_16 = {
  key: 5,
  class: "van-hairline--bottom"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "工商运营执照号", -1))
const _hoisted_18 = { class: "van-hairline--bottom" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "邮箱地址", -1))

import { Form, FieldRule, Field, FormInstance } from 'vant'
import { withDefaults, reactive, computed, Ref, ref } from 'vue'
import { useValidateIDCard, useValiedateEmail } from '@/compositions/useValidate'

import {
  getThirdLiabilityInsuranceOptions,
  ThirdLiabilityInsuranceTextTypeMap,
} from '@/defination/insurance'
import { batchPinganCorrectInformation } from '@/apis/three-liability-insurance'
import { showToastFail, showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import { ChangePingan2024ThirdPartyLiabilityInformationParams } from '@/types/three-liability-insurance'
import CommonRadioGroup from '@/components/CommmonRadioGroup.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { commonErrorHandle } from '@/utils/error-handle'
export type PinganCorrectPolicyItem = {
  policy_no: string
  phone: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'pingan2024-insured-person',
  props: {
    policy_no: { default: '' },
    phone: { default: '' },
    policyItems: { default: () => [] },
    useExternalSubmit: { type: Boolean, default: false }
  },
  emits: ['success', 'submit'],
  setup(__props: any, { emit: emits }) {

const props = __props as { policy_no: string, phone: string, policyItems: PinganCorrectPolicyItem[], useExternalSubmit: boolean };



const formValue = reactive({
  personnelType: '1',
  name: '',
  certificateNo: '',
  compnayName: '',
  compnayCertificateNo: '',
  groupName: '',
  groupCertificateNo: '',
  email: '',
  phone: props.phone,
})
const updated_by = '广州极飞科技股份有限公司'
const formVm: Ref<FormInstance | null> = ref(null)
const personalTypeOptions = getThirdLiabilityInsuranceOptions(false)
const personalTypeValue = '1' // 个人选项值
const companyTypeValue = '2' // 企业选项值
const groupTypeValue = '3' // 团体选项值 仅定义在前端，后端接口没有这个定义
const isApplicantPersonal = computed(() => {
  // 被保人个人
  return formValue.personnelType === personalTypeValue
})
const isApplicantCompany = computed(() => {
  // 被保人企业
  return formValue.personnelType === companyTypeValue
})
const isApplicantGroup = computed(() => {
  // 被保人团体
  return formValue.personnelType === groupTypeValue
})
const messagesMap = {
  groupName: '请填写团体名称',
  groupCertificateNo: '请填写工商运营执照号',
  compnayName: '请填写企业名称',
  compnayCertificateNo: '请填写企业的统一社会信用代码',
  personnelType: '请选择被保人类型',
  name: '请填写被保人姓名',
  certificateNo: '请填写被保人的身份证号码',
  email: '请填写邮箱地址',
  phone: '请填写被保人电话',
}
function stringFormatter(value: string) {
  return typeof value === 'string' ? value.trim() : value
}
function getFieldRuleConfig(childKey: unknown): FieldRule[] {
  type p = keyof typeof messagesMap
  const result: FieldRule[] = [
    {
      required: true,
      trigger: 'onBlur',
      message: messagesMap[childKey as p],
    },
  ]
  if (childKey === 'email') {
    result.push({
      validator: useValiedateEmail,
      message: '请输入正确的邮箱格式',
    })
  }
  if (childKey === 'certificateNo') {
    result.push({
      validator: useValidateIDCard,
      message: '请输入正确的身份证号码',
    })
  }
  return result
}
async function validateHandle(): Promise<boolean> {
  // 验证参数
  let validateValue = true
  try {
    await formVm.value?.validate() // Form表单验证不通过会
  } catch (error) {
    console.log('error', error)
    validateValue = false
  }
  if (!validateValue) {
    showToastFail('请完善表单信息后再提交')
  }
  return validateValue
}
async function beforeConfirmHandle() {
  const validateValue = await validateHandle()
  if (!validateValue) {
    return
  }
  confirmHandle()
}
function getNameAndCertificateNo() {
  const name = isApplicantPersonal.value
    ? formValue.name
    : isApplicantCompany.value
    ? formValue.compnayName
    : isApplicantGroup.value
    ? formValue.groupName
    : ''
  const certificate_no = isApplicantPersonal.value
    ? formValue.certificateNo
    : isApplicantCompany.value
    ? formValue.compnayCertificateNo
    : isApplicantGroup.value
    ? formValue.groupCertificateNo
    : ''
  return { name, certificate_no }
}

function getCorrectPolicyItems(): PinganCorrectPolicyItem[] {
  if (props.policyItems?.length) {
    return props.policyItems.map((item) => ({
      policy_no: item.policy_no,
      phone: item.phone,
    }))
  }
  if (props.policy_no) {
    return [{ policy_no: props.policy_no, phone: props.phone || formValue.phone }]
  }
  return []
}

function getSubmitParamsList(): ChangePingan2024ThirdPartyLiabilityInformationParams[] {
  const { name, certificate_no } = getNameAndCertificateNo()
  const base = {
    updated_by,
    name,
    email: formValue.email,
    personnel_type: formValue.personnelType,
    certificate_type: formValue.personnelType,
    certificate_no,
  }
  return getCorrectPolicyItems().map((item) => ({
    ...base,
    policy_no: item.policy_no,
    phone: item.phone,
  }))
}
async function confirmHandle() {
  try {
    await showConfirmModal({
      message: '是否确认批改?',
      className: 'repair-dialog',
    })
  } catch (error) {
    return
  }
  const params = getSubmitParamsList()
  if (!params.length) {
    showToastFail('请选择要批改的保单')
    return
  }
  if (props.useExternalSubmit) {
    emits('submit', params)
    return
  }
  showToastLoading()
  try {
    const data = await batchPinganCorrectInformation(params)
    if (data?.status === 400) {
      showToastFail(data.message)
      return
    }
    showToastSuccess('批改成功')
    emits('success')
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Form), {
      class: "main-info",
      ref_key: "formVm",
      ref: formVm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(CommonRadioGroup, {
                style: {"margin-top":"4px"},
                options: _unref(personalTypeOptions),
                value: formValue.personnelType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formValue.personnelType) = $event))
              }, {
                radioContent: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(data.label), 1),
                    _createElementVNode("div", null, "(" + _toDisplayString(_unref(ThirdLiabilityInsuranceTextTypeMap).get(data.value as string)) + ")", 1)
                  ])
                ]),
                _: 1
              }, 8, ["options", "value"])
            ]),
            (_unref(isApplicantPersonal))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValue.name) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.name,
                    rules: getFieldRuleConfig('name')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantPersonal))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.certificateNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formValue.certificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.certificateNo,
                    rules: getFieldRuleConfig('certificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantCompany))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.compnayName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValue.compnayName) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.compnayName,
                    rules: getFieldRuleConfig('compnayName')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantCompany))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.compnayCertificateNo,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formValue.compnayCertificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.compnayCertificateNo,
                    rules: getFieldRuleConfig('compnayCertificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantGroup))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.groupName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValue.groupName) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.groupName,
                    rules: getFieldRuleConfig('groupName')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantGroup))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_unref(Field), {
                    modelValue: formValue.groupCertificateNo,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValue.groupCertificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.groupCertificateNo,
                    rules: getFieldRuleConfig('groupCertificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_unref(Field), {
                modelValue: formValue.email,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValue.email) = $event)),
                class: "xa-field nongfu-field-wrap",
                formatter: stringFormatter,
                placeholder: messagesMap.email,
                rules: getFieldRuleConfig('email')
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(CommonFooterNextButton, {
      title: "保存",
      class: "confirm-button",
      onClick: beforeConfirmHandle
    })
  ]))
}
}

})